import { addModal } from 'modules/messageSystem/actions/addModal';
import {
  MODAL_TERMS_AND_CONDITIONS,
  MODAL_TERMS_AND_CONDITIONS_LOGIN,
  MODAL_TERMS_AND_CONDITIONS_APPROVE_DECLINE_MODAL,
} from 'modules/messageSystem/constants/modalCodes';

import createAction from './';
import { fetchTermsAndConditions } from './termsAndConditions';

export const TOS_ALREADY_APPROVED = createAction('TOS_ALREADY_APPROVED');
export const TOS_NEED_APPROVE = createAction('TOS_NEED_APPROVE');
export const TOS_DECLINED = createAction('TOS_DECLINED');
export const TOS_ACCEPTED = createAction('TOS_ACCEPTED');
export const TOS_DECLINE_CANCELED = createAction('TOS_DECLINE_CANCELED');
export const TOS_DECLINE_ACCEPTED = createAction('TOS_DECLINE_ACCEPTED');

export const showTermsAndConditionsModal = () => (dispatch, getState) => {
  return dispatch(fetchTermsAndConditions())
    .then(() => {
      const modalContent = getState().auth.loginForm.termsContent;

      dispatch(addModal({
        testId: 'login-tos-modal',
        typeId: MODAL_TERMS_AND_CONDITIONS_LOGIN,
        body: modalContent,
        onCancel: () => dispatch({ type: TOS_DECLINED }),
        onOk: () => dispatch({ type: TOS_ACCEPTED }),
        preventClosingWhenDismiss: true,
      }));
    });
};

export const showFooterTermsAndConditionsModal = () => (dispatch, getState) => {
  return dispatch(fetchTermsAndConditions())
    .then(() => {
      const modalContent = getState().auth.loginForm.termsContent;
      dispatch(addModal({
        testId: 'footer-tos-modal',
        typeId: MODAL_TERMS_AND_CONDITIONS,
        body: modalContent,
      }));
    });
};

export const showAcceptDeclineTermsAndConditionsModal = () => (dispatch) => {
  dispatch(addModal({
    testId: 'accept-decline-tos-modal',
    typeId: MODAL_TERMS_AND_CONDITIONS_APPROVE_DECLINE_MODAL,
    onCancel: () => dispatch({ type: TOS_DECLINE_CANCELED }),
    onOk: () => dispatch({ type: TOS_DECLINE_ACCEPTED }),
    preventClosingWhenDismiss: true,
  }));
};
